import { render } from "./ForumPostEdit.vue?vue&type=template&id=64162e52&scoped=true"
import script from "./ForumPostEdit.vue?vue&type=script&lang=js"
export * from "./ForumPostEdit.vue?vue&type=script&lang=js"

import "./ForumPostEdit.vue?vue&type=style&index=0&id=64162e52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64162e52"]])

export default __exports__